export default "__VITE_ASSET__CawP$TEp__"